export const rangeOptions = [
    {
        value: '',
        label: '全部对象',
    },
    {
        value: 'subscribed',
        label: '已订阅',
    },
    {
        value: 'unsubscribed',
        label: '未订阅',
    },
]

export const tableColumns = [
    {
        title: '中文名称',
        dataIndex: 'cnName',
        key: 'cnName',
    },
    {
        title: '英文名称',
        dataIndex: 'enName',
        key: 'enName',
    },
    {
        title: '国别',
        dataIndex: 'country',
        key: 'country',
    },
  ]
